import React, { useEffect } from "react";
import "../../dynamic/TennisTech/classified-surface.scss";

export const ResponsiveTableScript = () => {
  Array.from(document.querySelectorAll(".responsive-table table")).forEach(
    (table: HTMLElement) => {
      const tableHeader = table.querySelector(".table-header");
      const tableHeaderSecondary = table.querySelector(
        ".table-header--secondary"
      );

      if (tableHeader !== null) {
        const newHeader = document.createElement("thead");
        newHeader.innerHTML = Array.from(
          tableHeader.querySelectorAll("td")
        ).reduce((html, td) => {
          html += `<th>${td.innerHTML}</th>`;
          return html;
        }, "");

        if (tableHeaderSecondary) {
          newHeader.innerHTML = `${tableHeaderSecondary.innerHTML}${newHeader.innerHTML}`;
          tableHeaderSecondary.remove();
        }
        table.appendChild(newHeader);
        tableHeader.remove();
      }

      const tableRows = Array.from(table.querySelectorAll("tbody tr")).filter(
        tr => tr.getAttribute("class") !== "table-header"
      );

      if (tableRows.length > 0) {
        tableRows.forEach(tr => {
          const tableData = Array.from(tr.querySelectorAll("td"));
          const tableHeader: HTMLElement[] = Array.from(
            table.querySelectorAll("thead th")
          );
          const mobileTableDataHTML = `${tableData.reduce((html, td, key) => {
            html += `<td>
              <span class="classified-surface__type-pressure">
                <span>${
                  tableHeader.length ? tableHeader[key].innerText + ": " : ""
                }${td.innerText}</span>
              </span>
            </td>`;
            return html;
          }, "")}`;
          const tableMobileData = document.createElement("td");
          tableMobileData.className =
            "classified-surface__mobile-table-cell classified-surface__mobile-table-cell--hidden";
          tableMobileData.innerHTML = mobileTableDataHTML;
          tr.appendChild(tableMobileData);

          tableData.forEach((td: HTMLElement, key: number) => {
            const p = td.querySelector("p");
            if (p) {
              const text = p.innerText.trim();
              if (["&nbsp;", "*", ""].includes(text)) {
                td.classList.add("asterisk");
              }
            }
            if (key > 0) {
              td.classList.add("classified-surface__desktop-table-cell");
            } else {
              td.innerHTML = `<span class="classified-surface__surface-title">
                <span>${td.innerHTML}</span>
                <button class="accordion__toggle-btn accordion__toggle-btn--hidden"></button>
              </span>`;
              const lastChild = tr.querySelector(
                ".classified-surface__mobile-table-cell"
              );
              td.addEventListener("click", () => {
                const button = td.querySelector(".accordion__toggle-btn");
                if (button) {
                  button.classList.toggle("accordion__toggle-btn--hidden");
                }
                if (lastChild !== null) {
                  lastChild.classList.toggle(
                    "classified-surface__mobile-table-cell--hidden"
                  );
                }
              });
            }
          });
        });
      }
    }
  );
};

export default () => {
  useEffect(() => {
    ResponsiveTableScript();
  }, []);
  return (
    <table className="classified-surface__table">
      <tbody style={{ width: "100%" }}>
        <tr className="table-header">
          <td>
            <p>
              <strong>Vendor</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>System</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Classification</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Indoor</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Outdoor</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Hard</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Grass</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Clay</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Hard</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Grass</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Clay</strong>
            </p>
          </td>
        </tr>

        <tr className="table-header--secondary">
          <td> </td>
          <td>
            <p> </p>
          </td>
          <td>
            <p> </p>
          </td>
          <td colSpan={2}>
            <p>
              <strong>Setting</strong>
            </p>
          </td>
          <td colSpan={3}>
            <p>
              <strong>Review</strong>
            </p>
          </td>
          <td colSpan={3}>
            <p>
              <strong>Real-time</strong>
            </p>
          </td>
        </tr>

        <tr>
          <td>
            <p>
              <a href="https://www.hawkeyeinnovations.com/">Hawk-Eye</a>
            </p>
          </td>
          <td>
            <p>Hawk-Eye</p>
          </td>
          <td>
            <p>Gold</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
          <td>
            <p>Y</p>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
